"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/prefer-default-export, camelcase */
var rest_1 = __importDefault(require("../../../rest"));
var coursesApi_1 = require("../../mock/learningPanel/coursesApi");
var coreServiceUrl = process.env.CB_CORE_SERVICE_SERVER_URL;
var CourseAPIs = {
    getCourse: function (courseUuid, token) {
        return rest_1.default.get({
            mockFunc: function () { return coursesApi_1.mockCourse; },
            url: "".concat(coreServiceUrl, "/course/").concat(courseUuid),
            token: token,
        });
    },
};
exports.default = CourseAPIs;
